import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import AccordionWrapper from '../AccordionWrapper/AccordionWrapper';
import PatientCardSectionLabel from '../Assessments/sidebar/PatientCardSectionLabel';

// Wrapper to maintain consistent styling with patient card sections
const PatientCardSection = styled.div`
    margin: 20px 0;

    .accordion-wrapper {
        padding-top: 0;
    }
`;

// Custom header component for the accordion
const CustomHeaderContent = ({ onClick, title, isVisible, setIsVisible, className }) => (
    <PatientCardSectionLabel
        className={className}
        onClick={() => {
            setIsVisible(!isVisible);
            onClick?.(isVisible);
        }}
    >
        <i className={`fa fa-caret-right caret-icon ${isVisible ? 'expanded' : ''}`} />
        {title}
    </PatientCardSectionLabel>
);

CustomHeaderContent.propTypes = {
    onClick: PropTypes.func,
    title: PropTypes.string.isRequired,
    isVisible: PropTypes.bool.isRequired,
    setIsVisible: PropTypes.func.isRequired,
    className: PropTypes.string,
};

CustomHeaderContent.defaultProps = {
    onClick: null,
    className: '',
};

const propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: '',
};

const CollapsiblePatientCardSection = ({ title, children, className }) => {
    return (
        <PatientCardSection className={className}>
            <AccordionWrapper title={title} stateKey={`collapsiblePC-${title}`} HeaderContent={CustomHeaderContent}>
                {children}
            </AccordionWrapper>
        </PatientCardSection>
    );
};

CollapsiblePatientCardSection.propTypes = propTypes;
CollapsiblePatientCardSection.defaultProps = defaultProps;

export default CollapsiblePatientCardSection;
